import { Close } from "@mui/icons-material";
import { DialogContent } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getDocuments } from "../../../../../../actions/accidentDashboard";
import {
  dismissConnectivityErrorAction,
  getConnectivityErrors,
} from "../../../../../../actions/connectivityResponse";
import snackbarUtils from "../../../../../../utils/snackbarUtils";
import CircularLoading from "../../../../../commons/loadingData/circularLoading";
import { StyledDialog } from "../../../../../styled/dialog";
import { StyledFlex } from "../../../../../styled/flex";

import CustomDialog from "../../../../../commons/dialog/customDialog";
import CardTitle from "../../cardTitle";
import ErroresConectividadCardDetail from "./ErroresConectividadCardDetail";

const ErroresConectividadDialog = ({
  open,
  handleClose,
  selectedDocument,
  handleOpenDetail,
}) => {
  const dispatch = useDispatch();
  const erroresConectividad = useSelector(
    (state) => state.connectivityResponse.connectivityErrors,
  );
  const accident = useSelector((state) => state.accidentDashboard.accident);
  const desestimarErrorConectividad = (error) => {
    dispatch(
      dismissConnectivityErrorAction(
        error.idRespError,
        accident.mlCloudCoreArtId,
      ),
    ).then(() =>
      dispatch(
        getConnectivityErrors(
          selectedDocument.nroTransaccion,
          accident.mlCloudCoreArtId,
        ),
      ).then((res) => {
        dispatch(getDocuments(accident.idSiniestro, accident.mlCloudCoreArtId));
        snackbarUtils.success("Error desestimado correctamente");
      }),
    );
  };

  const hayErrroresConectividad = erroresConectividad.data.filter(
    (e) => e.error === true,
  ).length > 0;
  const icons = [
    {
      Icon: Close,
      tooltip: "Cerrar",
      onClick: handleClose,
      disabled: false,
    },
  ];

  return (
    <CustomDialog open={open} onClose={handleClose}>
      <CardTitle title={hayErrroresConectividad ? "Errores" : "Respuesta Conectividad"} color="primary" icons={icons} />
      {erroresConectividad.isFetching ? (
        <StyledDialog.LoadingContainer>
          <CircularLoading />
        </StyledDialog.LoadingContainer>
      ) : (
        <DialogContent>
          <StyledFlex.ColumnContainer>
            {(
              erroresConectividad.data.map(
                (e) =>
                  <ErroresConectividadCardDetail
                    news={{
                      ...e,
                      observaciones: e.respuesta,
                    }}
                    handleOpenDetail={handleOpenDetail}
                    selectedDocument={selectedDocument}
                    desestimarErrorConectividad={desestimarErrorConectividad}
                  />
              )
            )}
          </StyledFlex.ColumnContainer>
        </DialogContent>
      )}
    </CustomDialog>
  );
};

export default ErroresConectividadDialog;
